import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import img11 from "./Assets/11.png";
import img12 from "./Assets/12.png";
import logo from "./Assets/bfbsnw.png";

export default class BlazinFireballsSpinNWinConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12];
        this.logo = logo;

        //Game Name
        this.name = "Blazin Fireballs Spin N Win";
        this.disabled = true

        //General Config
        this.reels = 5;
        this.symbolPerReel = 4;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 12;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
    }
}
